import {
	createFileRoute,
	Outlet,
	redirect,
	stripSearchParams,
} from "@tanstack/react-router";
import { fetchQuery, graphql } from "react-relay";
import { z } from "zod";
import type { routeCommunityShellEnabledQuery } from "./__generated__/routeCommunityShellEnabledQuery.graphql";
import { environment } from "@/relay/environment";
import { Spinner } from "@/components/ui/spinner";
import { CommunityShell } from "@/ui/community-shell";

const defaultValues = {
	order: "newest",
} as const;

export const Route = createFileRoute(
	"/_visibility/_topnav/_tabs/_sidebar/comunidade",
)({
	component: RouteComponent,
	pendingComponent: () => {
		return (
			<div className="size-full flex flex-col items-center justify-center py-12">
				<Spinner />
			</div>
		);
	},
	pendingMinMs: 300,
	validateSearch: z.object({
		order: z.enum(["newest", "oldest", "trending"]).default("newest"),
	}),
	search: {
		middlewares: [stripSearchParams(defaultValues)],
	},
	loader: async ({ context }) => {
		const { club } = context;

		const data = await fetchQuery<routeCommunityShellEnabledQuery>(
			environment,
			graphql`
		    query routeCommunityShellEnabledQuery($slug: String!) {
		      club(slug: $slug) {
				    configuration(key: "COMMUNITY_ENABLED")
			    }
		    }
	`,
			{ slug: club.slug },
		).toPromise();

		if (data?.club.configuration?.length && data?.club.configuration !== "1") {
			throw redirect({
				to: "/",
			});
		}
	},
});

function RouteComponent() {
	return (
		<CommunityShell>
			<Outlet />
		</CommunityShell>
	);
}
